import { Injectable } from '@angular/core';

export type ContactContent = {
  badge: string;
  heading: string;
  lede: string;
  note: string;
};

@Injectable({ providedIn: 'root' })
export class ContactSectionService {
  readonly content: ContactContent = {
    badge: 'Contact Us',
    heading: 'We are here to help your pet feel their best.',
    lede:
      'Tell us about your pet and the care they need. Our team will get back to you with calm, clear guidance.',
    note: 'We reply within 1-2 business days.'
  };
}
